var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"StartButton",on:{"click":function($event){return _vm.startGame()}}},[_vm._v(" "+_vm._s(_vm.$t('components.start-button.start'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }